namespace Application.Common {
   'use strict';

    export var CONTINUE: number = 100;
    export var SWITCHING_PROTOCOLS: number = 101;
    export var PROCESSING: number = 102;
    export var OK: number = 200;
    export var CREATED: number = 201;
    export var ACCEPTED: number = 202;
    export var NON_AUTHORITATIVE_INFORMATION: number = 203;
    export var NO_CONTENT: number = 204;
    export var RESET_CONTENT: number = 205;
    export var PARTIAL_CONTENT: number = 206;
    export var MULTI_STATUS: number = 207;
    export var MULTIPLE_CHOICES: number = 300;
    export var MOVED_PERMANENTLY: number = 301;
    export var MOVED_TEMPORARILY: number = 302;
    export var SEE_OTHER: number = 303;
    export var NOT_MODIFIED: number = 304;
    export var USE_PROXY: number = 305;
    export var TEMPORARY_REDIRECT: number = 307;
    export var BAD_REQUEST: number = 400;
    export var UNAUTHORIZED: number = 401;
    export var PAYMENT_REQUIRED: number = 402;
    export var FORBIDDEN: number = 403;
    export var NOT_FOUND: number = 404;
    export var METHOD_NOT_ALLOWED: number = 405;
    export var NOT_ACCEPTABLE: number = 406;
    export var PROXY_AUTHENTICATION_REQUIRED: number = 407;
    export var REQUEST_TIME_OUT: number = 408;
    export var CONFLICT: number = 409;
    export var GONE: number = 410;
    export var LENGTH_REQUIRED: number = 411;
    export var PRECONDITION_FAILED: number = 412;
    export var REQUEST_ENTITY_TOO_LARGE: number = 413;
    export var REQUEST_URI_TOO_LARGE: number = 414;
    export var UNSUPPORTED_MEDIA_TYPE: number = 415;
    export var REQUESTED_RANGE_NOT_SATISFIABLE: number = 416;
    export var EXPECTATION_FAILED: number = 417;
    export var IM_A_TEAPOT: number = 418;
    export var UNPROCESSABLE_ENTITY: number = 422;
    export var LOCKED: number = 423;
    export var FAILED_DEPENDENCY: number = 424;
    export var UNORDERED_COLLECTION: number = 425;
    export var UPGRADE_REQUIRED: number = 426;
    export var PRECONDITION_REQUIRED: number = 428;
    export var TOO_MANY_REQUESTS: number = 429;
    export var REQUEST_HEADER_FIELDS_TOO_LARGE: number = 431;
    export var INTERNAL_SERVER_ERROR: number = 500;
    export var NOT_IMPLEMENTED: number = 501;
    export var BAD_GATEWAY: number = 502;
    export var SERVICE_UNAVAILABLE: number = 503;
    export var GATEWAY_TIME_OUT: number = 504;
    export var HTTP_VERSION_NOT_SUPPORTED: number = 505;
    export var VARIANT_ALSO_NEGOTIATES: number = 506;
    export var INSUFFICIENT_STORAGE: number = 507;
    export var BANDWIDTH_LIMIT_EXCEEDED: number = 509;
    export var NOT_EXTENDED: number = 510;
    export var NETWORK_AUTHENTICATION_REQUIRED: number = 511;
}